import React from "react";
import Modal from "../Modal/Modal";
import { LeftArrowIcon } from "../../../../assets/icons/svgicons";
import goldenLogo from "../../../../assets/logos/golden-logo.svg";
import Button from "../../Button/Button";
import styles from "../PaymentCompleted/PaymentCompleted.module.scss";

const KycApprovedModal = ({ show, onDismiss, onApplyNow, isSuccess = true }) => {

  return (
    <Modal
      show={show}
      title={
        <span onClick={onDismiss}>
          <LeftArrowIcon /> {isSuccess ? "Back" : "Close"}
        </span>
      }
      hideCloseBtn
      handleClose={onDismiss}
      className={styles.payment_complete}
    >
      <img className={styles.logo} src={goldenLogo} alt="" />
      {isSuccess ? (
        <>
          <h3>Thank you! You&apos;re all set.</h3>
          <p>Your verification is complete and approved.</p>
          <p>You can now apply for your STBL Money Card</p>
          <Button className={styles.check_btn} fluid onClick={onApplyNow}>
            Apply Now
          </Button>
        </>
      ) : (
        <>
          <h3>Verification Failed</h3>
          <p>Your KYC verification failed.</p>
          <Button className={styles.check_btn} fluid onClick={onDismiss}>
            Close
          </Button>
        </>
      )}
    </Modal>
  );
};

export default KycApprovedModal;
